import script from "./HistoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./HistoryDialog.vue?vue&type=style&index=0&id=014f48f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014f48f6"]])

export default __exports__